
class harrisoncarousel {

    /**
     * Timeout objecct for this carousel
     * @type {null}
     */
    timeout = null;
    /**
     * If the carousel is in transit, disarm all actions
     * @type {boolean}
     */
    in_transit = false;

    blocks = null;
    section_id = null;
    carousel = null;

    constructor(section_id) {

        console.log( section_id + ' section_id ' );

        this.section_id = section_id;
        this.carousel = $('#' + section_id);
        if (this.carousel.offsetWidth < this.carousel.scrollWidth ) {
            return;
        }

        $('#' + section_id).addClass( 'carousel-active' );

        this.blocks = $('#' + section_id).children( 'ul' );
        this.apply_sizes();

        this.autoplay = this.carousel.data('autoplay') ?? true;
        this.autoplay_interval = this.carousel.data('autoplay-interval') ?? 5000;

        if ( this.autoplay === true ) {
            this.launch_timeout();
            this.arm_hovers();
        }

        const instance = this;
        $('body').on('click', '#' + section_id + ' .slider-button--next', function() {
            instance.do_next();
        });
        $('body').on('click', '#' + section_id + ' .slider-button--prev', function() {
            instance.do_prev();
        });

        $(window).resize(function() {
            clearTimeout($.data(this, 'resizeTimer'));
            $.data(this, 'resizeTimer', setTimeout(function() {
                instance.apply_sizes();
            }, 200));
        });
    }

    apply_sizes() {
        this.carousel.removeAttr( 'style' );
        this.blocks.removeAttr( 'style' );
        this.carousel.css({
            height: this.carousel.outerHeight() + 'px',
            position: 'relative'
        });
        this.blocks.css({
            width: this.carousel.width() + 'px',
            position: 'absolute'
        });

    }

    /**
     * If a user hovers over the carousel, clear teh timeout and only rearm it on mouseout
     * @return {void}
     */
    arm_hovers() {
        const instance = this;
        this.blocks.hover( function () {
            if ( instance.timeout ) {
                window.clearTimeout( instance.timeout );
            }
        }, function() {
            instance.launch_timeout();
        });
    }

    /**
     * Trigger a right-hand scroll after a period of inactivity
     * @return {void}
     */
    launch_timeout() {
        const instance = this;
        window.clearTimeout( this.timeout );
        this.timeout = window.setTimeout( function() {
            instance.do_next();
        }, this.autoplay_interval );
    }

    /**
     * Work how wide the child plus the margin is
     * @returns {jQuery|*|string|number}
     */
    get_width() {
        let this_left = this.blocks.children().eq(1).position();
        this.offset = this_left.left - 24;
    }

    /**
     * Do the things required before launching a transition
     * @return {void}
     */
    start_transition() {
        this.in_transit = true;
        window.clearTimeout( this.timeout );
        this.get_width();
    }

    /**
     * Reset internal variables and launch the next timeout
     * @return {void}
     * */
    complete_transition() {
        this.in_transit = false;
        this.launch_timeout();
    }

    /**
     * Scroll right
     * @return {void}
     */
    do_next() {
        if (this.in_transit) {
            return;
        }
        this.start_transition();
        const instance = this;
        console.log( this.section_id + ' about to animate ' + this.offset );
        this.blocks.animate( {
            left: '-' + instance.offset + 'px'
        }, 500, function() {
            const first_child = instance.blocks.children(":first");
            instance.blocks.append( first_child.clone( true ) );
            first_child.remove();
            instance.blocks.css({
                left: 12 + 'px'
            });
            instance.complete_transition();
        });

    }
    /**
     * Scroll left
     * @return {void}
     */
    do_prev() {
        if (this.in_transit) {
            return;
        }
        this.start_transition();

        const last_child = this.blocks.children(":last");
        this.blocks.prepend( last_child.clone( true ) );

        const instance = this;
        this.blocks.css({
            left: '-' + instance.offset + 'px'
        }).animate({
            left: '12px'
        }, function() {
            last_child.remove();
            instance.complete_transition();
        });
    }

}
